
namespace TabAurous.ECommerce {

    @Serenity.Decorators.registerClass()
    export class ECommRepairTaxGrid extends Serenity.EntityGrid<ECommRepairTaxRow, any> {
        protected getColumnsKey() { return 'ECommerce.ECommRepairTax'; }
        protected getIdProperty() { return ECommRepairTaxRow.idProperty; }
        protected getInsertPermission() { return ECommRepairTaxRow.insertPermission; }
        protected getLocalTextPrefix() { return ECommRepairTaxRow.localTextPrefix; }
        protected getService() { return ECommRepairTaxService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
    }
}